import { createSlice } from "@reduxjs/toolkit";
import {
  AddCustomerApi,
  getCustomers,
  updateCustomerApi,
} from "../../reduxApi/admin/CustomerReduxApi";
const CustomerSlice = createSlice({
  name: "customers",
  initialState: {
    customers: [],
    updateCustomer: [],
    AddCustomer: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getCustomers.fulfilled, (state, action) => {
        state.status = "fulfilled";
        console.log("customer action", action.payload);
        state.customers = action.payload.customers;
        console.log("custom", state.customers);
      })
      .addCase(updateCustomerApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        console.log("customer action", action.payload);
        state.updateCustomer = action.payload;
        console.log("custom", state.updateCustomer);
      })
      .addCase(AddCustomerApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        console.log("customer action", action.payload);
        state.AddCustomer = action.payload;
        console.log("custom", state.AddCustomer);
      });
  },
});
// export const { deleteOrdersAction, updateOrdersAction, addOrdersAction } = OrdersSlice.actions
export default CustomerSlice.reducer;
